import { render, staticRenderFns } from "./CustomerInfo.vue?vue&type=template&id=1df8658c&scoped=true"
import script from "./CustomerInfo.vue?vue&type=script&lang=js"
export * from "./CustomerInfo.vue?vue&type=script&lang=js"
import style0 from "./CustomerInfo.vue?vue&type=style&index=0&id=1df8658c&prod&lang=scss&scoped=true"
import style1 from "./CustomerInfo.vue?vue&type=style&index=1&id=1df8658c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df8658c",
  null
  
)

export default component.exports